import React from 'react';
import { motion } from 'framer-motion';
export function SocialProofBar() {
  const stats = [{
    number: '+300',
    label: 'hombres lo aplicaron'
  }, {
    number: '3',
    label: 'Módulos del sistema'
  }, {
    number: '5',
    label: 'Bonos incluidos'
  }, {
    number: '4.9/5',
    label: 'calificación ⭐'
  }];
  return <section className="bg-bg-card border-y border-border-subtle py-12 px-4" data-id="element-218">
      <div className="max-w-6xl mx-auto" data-id="element-219">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-220">
          {stats.map((stat, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="text-center" data-id="element-221">
              <div className="text-text-gold text-4xl md:text-5xl font-black mb-2" data-id="element-222">
                {stat.number}
              </div>
              <div className="text-text-secondary text-[13px] uppercase tracking-wider" data-id="element-223">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}